import { j as o } from "../../../jsx-runtime-p91LotPX.mjs";
import { u as k, t as C } from "../../../table-XsUAem3c.mjs";
import { GrowCheckBox as g } from "../../CheckBox/AntCheckBox.js";
import { formatAmountShort as y, formatCurrency as j } from "../../utils/number-formatter.js";
import { GrowFlex as h } from "../../Flex/Flex.js";
import { getFormattedDate as m } from "../../utils/datetime-formatter.js";
import { EllipsisIconRegular as S } from "../../../Icons/Icons.js";
import v, { useState as x, useEffect as a, cloneElement as A } from "react";
import { StatusTag as w } from "../../StatusTag/StatusTag.js";
import { GrowTypography as u } from "../../Typography/AntTypography.js";
import { D as b } from "../../../index-CgEpbOWw.mjs";
function H(e) {
  return /* @__PURE__ */ o.jsx(u.Text, { ...e.textCellProps, children: e.value ?? "-" });
}
function I(e) {
  const {
    value: l,
    textCellProps: t,
    dateCellProps: n
  } = e;
  return /* @__PURE__ */ o.jsx(u.Text, { ...t, children: l ? m(l, n == null ? void 0 : n.format) : "-" });
}
function K(e) {
  var l, t;
  return /* @__PURE__ */ o.jsx(w, { text: (l = e.statusCellProps) == null ? void 0 : l.getter(e.value).label, style: (t = e.statusCellProps) == null ? void 0 : t.getter(e.value).style });
}
function p(e) {
  const {
    node: l
  } = e, [t, n] = x(!!l.isSelected()), i = k(C);
  return a(() => {
    const c = () => {
      n(!!l.isSelected());
    };
    return l.addEventListener("rowSelected", c), () => {
      l.removeEventListener("rowSelected", c);
    };
  }, [l]), /* @__PURE__ */ o.jsx(g, { design: "border-design", checked: t || i.selectAll.select_all, disabled: i.selectAll.select_all, onChange: (c) => {
    n(c.target.checked), l.setSelected(c.target.checked, void 0, void 0, "checkboxSelected");
  }, style: e.style });
}
function Q(e) {
  var i, c, r;
  const [l, t] = x(), n = (i = e.quickOperations) != null && i.component ? v.cloneElement((c = e.quickOperations) == null ? void 0 : c.component, {
    api: e.api,
    selectedRows: l ? [{
      id: String(e.node.id),
      data: e == null ? void 0 : e.data
    }] : [],
    selectedKey: l,
    onClose() {
      t(void 0);
    }
  }) : null;
  return /* @__PURE__ */ o.jsxs(h, { align: "center", space: "4", justify: "center", children: [
    /* @__PURE__ */ o.jsx(b, { menu: {
      items: (r = e.quickOperations) == null ? void 0 : r.items,
      onClick: (d) => {
        var s, f;
        t(d.key), d.key && ((f = (s = e.quickOperations) == null ? void 0 : s.onClick) == null || f.call(s, d.key, [{
          id: String(e.node.id),
          data: e == null ? void 0 : e.data
        }]));
      }
    }, trigger: ["click"], placement: "bottomLeft", children: /* @__PURE__ */ o.jsx("div", { style: {
      cursor: "pointer"
    }, children: /* @__PURE__ */ o.jsx(S, {}) }) }),
    l ? /* @__PURE__ */ o.jsx("div", { style: {
      display: "none",
      height: 0
    }, children: n }) : null
  ] });
}
function V(e) {
  return e.checkBoxComponent ? /* @__PURE__ */ o.jsxs(h, { align: "center", space: "2", children: [
    /* @__PURE__ */ o.jsx(p, { ...e, style: {
      width: "40px"
    } }),
    A(e.checkBoxComponent, {
      ...e
    })
  ] }) : null;
}
function W(e) {
  const {
    value: l,
    amountTextProps: t
  } = e;
  if (!l)
    return;
  const {
    amount: n,
    currency: i
  } = l, c = (t == null ? void 0 : t.format) === "SHORT" ? y(n, i, t == null ? void 0 : t.locale) : j(n, {
    currency: i,
    locale: t == null ? void 0 : t.locale
  }), r = /* @__PURE__ */ o.jsx(u.Text, { ...t == null ? void 0 : t.textProps, children: `${(t == null ? void 0 : t.prefix) ?? ""} ${c}` });
  return /* @__PURE__ */ o.jsx(o.Fragment, { children: r });
}
export {
  W as AmountCell,
  p as CellSelection,
  V as CellWithCheckBox,
  I as DateCell,
  Q as QuickOperations,
  K as StatusCell,
  H as TextCell
};
//# sourceMappingURL=DefaultCellComponents.js.map
